module.exports = __webpack_public_path__ + "static/media/logo2.f0812c30.png";